module.exports = __webpack_public_path__ + "88ea306ff9923b46373b9c2fce39dc90.svg";